import { lazy } from 'react';

export const TournamentsListPageAsync = lazy(() =>
  import('./TournamentsListPage').then((m) => ({ default: m.TournamentsListPage })),
);
